import { connect } from 'react-redux'
import Menu from '../Components/Menu'
import { mapStateToPropsAddable } from '../Utils/mapToProps'

const mapStateToProps = (state, ownProps) => ({
    ...mapStateToPropsAddable(state, ownProps),
    gridElements: ['label','blank','titre','blank2','bouton1', 'bouton2'],
    spanElements: ['texte'],
    refs: id => ({
        label: {
            type: 'LabelAdd',
            label: 'textexpl'
        },
        blank: {
            type: 'Blank'
        },
        titre: {
            type: 'InputTextContainer',
            name: `${id}/titre`,
            label: 'titre'
        },
        blank2: {
            type: 'Blank'
        },
        bouton1: {
            type: 'InputTextContainer',
            name: `${id}/btn1`,
            label: 'btn1'
        },
        bouton2: {
            type: 'InputTextContainer',
            name: `${id}/btn2`,
            label: 'btn2'
        },
        texte: {
            type: 'TextAreaContainer',
            name: `${id}/texte`
        }
    })
})

export default connect(
    mapStateToProps
)(Menu)

